import {useIsQualitySealVisible} from '@dms/shared';

import {useCanReadVehicleAdvertisingSettings} from './useCanReadVehicleAdvertisingSettings';

export function useIsVehicleQualitySealShown(vehicleId?: string): boolean {
  const canReadAdvertisingSettings = useCanReadVehicleAdvertisingSettings(vehicleId);

  return useIsQualitySealVisible() && canReadAdvertisingSettings;
}
